import React, { useContext, useEffect } from 'react';
import { AdminRole, DetTunerAdminRole } from '../../../model/constants'
import { UsersContext } from '../../../context/users-context';
import { DetTunersContext } from '../../../context/dettuners-context';
import * as DetTunerWorker from '../../../workers/detTunerWorker'
import TableComponent from '../TableComponent'
import { TextField } from '@material-ui/core';

const boardTypes = {
  xd_main: "Плата управления",
  xd_readout: "Плата считывания",
  xd_scanner: "Плата сканирования",
  xd_abs: "Плата ССЯ",
  xd_IoCard: "Плата ввода/вывода"
};

export default function BoardsTable(props) {
  console.log("render BoardsTable");

  const [usersState] = useContext(UsersContext);
  const [detTunersState, detTunersDispatch] = useContext(DetTunersContext);

  const [error, setError] = React.useState("");
  const [addRowData, setAddRowData] = React.useState(undefined);

  const isAdmin = usersState.currentUser?.Role === AdminRole;
  const isTunerAdmin = isAdmin || usersState.currentUser?.Role === DetTunerAdminRole;

  const getData = async () => {
    if (!detTunersState.tuners.length) {
      const tuners = await DetTunerWorker.GetTuners(usersState.token);
      detTunersDispatch({ type: 'SETTUNERS', payload: tuners });
    }
    const boards = await DetTunerWorker.GetBoards(usersState.token);
    detTunersDispatch({ type: 'SETBOARDS', payload: boards });
  }

  const mapTuners = () => Object.assign({}, ...detTunersState.tuners.map(t => ({ [t.TunerId]: t.Comment ?? t.TunerId })));

  const columns = [
    { field: 'BoardDesignation', title: 'Обозначение', sortable: true, editable: 'onAdd', validate: rowData => rowData.ParentID ? true : !!rowData.BoardDesignation, initialEditValue: addRowData?.BoardDesignation },
    { field: 'BoardType', title: 'Наименование', sortable: true, editable: 'onAdd', lookup: boardTypes, validate: rowData => rowData.ParentID ? true : !!rowData.BoardType, initialEditValue: addRowData?.BoardType },
    { field: 'BoardManufacturingDate', title: 'Дата изготовления платы'/*, editable: 'onAdd'*/, validate: rowData => rowData.ParentID ? true : !!rowData.BoardManufacturingDate, initialEditValue: addRowData?.BoardManufacturingDate },
    { field: 'BoardManufacturerCode', title: 'Код изготовителя'/*, editable: 'onAdd'*/, validate: rowData => rowData.ParentID ? true : !!rowData.BoardManufacturerCode, initialEditValue: addRowData?.BoardManufacturerCode },
    { field: 'SerialNumber', title: 'Порядковый номер платы'/*, editable: 'onAdd'*/, validate: rowData => rowData.ParentID ? true : !!rowData.SerialNumber, initialEditValue: addRowData?.SerialNumber },
    { field: 'Firmware', title: 'Версия прошивки'/*, editable: 'onAdd'*/, validate: rowData => rowData.ParentID ? true : !!rowData.Firmware, initialEditValue: addRowData?.Firmware },
    { field: 'UID', title: 'UID'/*, editable: 'onAdd'*/, validate: rowData => rowData.ParentID ? true : !!rowData.UID, initialEditValue: addRowData?.UID },
    { field: 'MAC', title: 'MAC-адрес'/*, editable: 'onAdd'*/, initialEditValue: addRowData?.MAC },
    { field: 'CreationDate', title: 'Дата добавления', type: 'datetime', dateSetting: { locale: navigator.language }, editable: 'never', initialEditValue: (new Date()).toJSON() },
    { field: 'DetTunerId', title: 'Тюнер', editable: 'onAdd', lookup: mapTuners(), validate: rowData => rowData.ParentID ? true : !!rowData.DetTunerId, initialEditValue: addRowData?.DetTunerId },
    {
      field: 'Comment', title: 'Примечания',
      render: (rowData) => (rowData.Comment ? (rowData.Comment + '').split('\n').map((item, key) => (<span key={key}>{item}<br /></span>)) : ''),
      editComponent: ({ value, onChange }) => (<TextField onChange={e => onChange(e.target.value)} value={value} multiline />),
      initialEditValue: addRowData?.Comment
    },

  ];

  const showError = (msg) => {
    setError(msg);
  }

  const onAdd = async (newData) => {
    let data = await DetTunerWorker.AddBoard(usersState.token, newData);
    if (data === undefined) {
      setAddRowData(newData);
      return Promise.reject();
    }
    if (data.error) {
      showError(data.error);
      setAddRowData(newData);
      return Promise.reject();
    }
    else {
      setAddRowData(undefined);
      detTunersDispatch({ type: 'UPDATEBOARD', payload: data });
    }
  };

  const onEdit = async (newData) => {
    let data = await DetTunerWorker.UpdateBoard(usersState.token, newData);
    if (data === undefined) {
      return Promise.reject();
    }
    if (data.error) {
      showError(data.error);
      return Promise.reject();
    }
    else
      detTunersDispatch({ type: 'UPDATEBOARD', payload: data });
  };

  const onDelete = async (oldData) => {
    let res = await DetTunerWorker.DeleteBoard(usersState.token, oldData.ID);
    if (res !== undefined)
      detTunersDispatch({ type: 'DELETEBOARD', payload: oldData.ID });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <TableComponent
      columns={columns}
      data={detTunersState.boards}
      canEdit={isTunerAdmin}
      options={{
        search: true
      }}
      parentChildData={(row, rows) => rows.find(a => a.ID === row.ParentID)}
      onRowAdd={onAdd}
      onRowAddCancelled={() => setAddRowData(undefined)}
      onRowUpdate={onEdit}
      onRowDelete={onDelete}
      onDeleteLabel={(row, defVal) => {
        let warn = "";
        if (row.UID)
          warn += `UID '${row.UID}' будет использован повторно.\n`;
        if (row.MAC)
          warn += `MAC '${row.MAC}' будет использован повторно.\n`;
        return warn + defVal;
      }}
      isEditHidden={(row) => !row.ParentID}
      isDeleteHidden={(row) => !row.ParentID}
      errorMsg={error} />
  );
}